<div
    *ngIf="!link"
    class="poster-image selenium-card-poster-image"
    [ngClass]="{ blured: !searchImage }"
    [ngStyle]="{
        'background-image': 'url(\'' + (searchImage ? searchImage : posterImage) + '\')'
    }"
>
    <div
        class="inner-poster-image"
        *ngIf="!searchImage"
        [ngStyle]="{ 'background-image': 'url(\'' + posterImage + '\')' }"
    ></div>
    <div *ngIf="resourceCount" class="resource-count">{{ resourceCount }}</div>
</div>

<a
    [routerLink]="link"
    *ngIf="link"
    [class]="getCollectionsPosterClass()"
    [attr.data-gtmlabel]="absoluteUrl"
>
    <div
        class="poster-image selenium-card-poster-image"
        [ngClass]="{ blured: !searchImage }"
        [ngStyle]="{
            'background-image': 'url(\'' + (searchImage ? searchImage : posterImage) + '\')'
        }"
    >
        <div
            class="inner-poster-image"
            *ngIf="!searchImage"
            [ngStyle]="{ 'background-image': 'url(\'' + posterImage + '\')' }"
        ></div>
        <div *ngIf="resourceCount" class="resource-count selenium-resource-collection-card-count">
            {{ resourceCount }}
        </div>
    </div>
</a>
